import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { useSidebar } from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/useAuth";
import { getNameChars } from "@/utils/helper";
import { googleLogout } from "@react-oauth/google";
import { ChevronsUpDown } from "lucide-react";
import { useRouter } from "next/router";
import { AiOutlineLogout } from "react-icons/ai";
import { MdOutlineAccountCircle } from "react-icons/md";
import NotificationBell from "./notificationBell";
import ThemeToggle from "../organisms/themeToggle";

export default function NavUser() {
  const { user, logout: logoutApi } = useAuth();
  const router = useRouter();
  const { open } = useSidebar();

  const handleLogout = async () => {
    try {
      googleLogout(); // Log out from Google (OAuth)
      // await apiLogout(); // Call your API logout
      logoutApi(); // Call the `useAuth` logout
      router.push("/on-board"); // Redirect to login
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <>
      <DropdownMenu>
        <div className="relative flex items-center gap-4 data[highlighted]:bg-gray-100  w-full ">
          <DropdownMenuTrigger asChild>
            <Avatar className="h-16 w-16   text-[2rem] font-bold leading-10 rounded-full ">
              <AvatarFallback className="bg-black/70 text-white capitalize">
                {getNameChars(user?.attributes?.name)}
              </AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          {open && (
            <div
              onClick={() => router.push("/account-settings/profile")}
              className="grid flex-1 text-left text-sm leading-tight cursor-pointer"
            >
              <span className="text-[1.6rem]  font-medium text-sidebar-foreground leading-[2rem] text-left  mb-2">
                {user?.attributes?.name}
              </span>
              <p className="truncate text-[1.2rem] font-semibold text-sidebar-foreground/70">
                Account Settings
              </p>
            </div>
          )}

          <DropdownMenuTrigger asChild>
            <div
              className={`cursor-pointer ${
                open ? "" : "opacity-0 pointer-events-none"
              }`}
            >
              <ChevronsUpDown className="ml-auto size-8 text-sidebar-foreground/70" />
            </div>
          </DropdownMenuTrigger>

          <div className="absolute -top-8 right-4 ">
            {open && <NotificationBell />}
          </div>
        </div>
        <DropdownMenuContent
          // side={"right"}
          className="min-w-[20rem] rounded-xl dark:border-input"
          align="start"
        >
          <DropdownMenuItem
            onClick={() => router.push("/account-settings/profile")}
            className={` px-4 py-4 flex gap-4 items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left`}
          >
            <MdOutlineAccountCircle
              className="text-foreground"
              style={{
                width: 16,
                height: 16,
              }}
            />
            Account Settings
          </DropdownMenuItem>

          <ThemeToggle />

          <Separator />
          <DropdownMenuItem
            onClick={handleLogout}
            className={` px-4 py-4 flex gap-4 items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left `}
          >
            <AiOutlineLogout
              style={{
                width: 16,
                height: 16,
              }}
              className="text-foreground"
            />
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
